var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-grid" },
    _vm._l(_vm.items, function (item, index) {
      return _c(_vm.componentName(item), {
        key: _vm.getId(item, index),
        tag: "component",
        attrs: { item: item, "hover-card-enabled": _vm.hoverCardSetting },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }